import * as React from "react";
import { WarningBanner } from "@graffer-inc/console-design-kit";
import { matchType } from "../../../../../application/domain/base/base-type";
import { Loading } from "../../../common/loading";
import { PaymentSummaryV2 } from "../common/payment-summary-v2";
import {
  PaymentCalcState,
  PaymentCalcStateLiterals,
  PaymentCalculateResult,
} from "./hooks";

export const CalculateResult: React.FC<{
  paymentResult: PaymentCalculateResult;
  state: PaymentCalcState;
}> = ({ state, paymentResult }) => {
  const { payment } = paymentResult;

  const errorMessage = React.useMemo(() => {
    switch (state.errorCode) {
      case "bad_request.payment_amount_is_less_than_minimum": {
        return "決済金額が2円以上になるように設定してください。";
      }
      default: {
        return "未入力項目を入力してください";
      }
    }
  }, [state.errorCode]);

  return (
    <div
      className={matchType<PaymentCalcStateLiterals, string>(state.step, {
        error: "mt-2 mb-2",
        refreshing: "mt-3 pl-1 has-text-centered",
        success: "pl-1",
      })}
    >
      {matchType<PaymentCalcStateLiterals, React.ReactNode>(state.step, {
        success: <PaymentSummaryV2 payment={payment!} />,
        refreshing: (
          <p className="has-text-centered">
            <Loading height="24px" width="24px" color="" />
          </p>
        ),
        error: <WarningBanner message={errorMessage} />,
      })}
    </div>
  );
};
